import { PageController } from '@client/components/_core/layout/PageController';
import { Tabs } from '@client/components/_core/navigation/Tabs';
import type { ShareableRouteContext } from '@client/types/router';
import { UI_SETTINGS } from '@client/utils';
import { formatRiskNumber } from '@client/utils/domain/risk';
import { createFileRoute } from '@tanstack/react-router';
import { useEffect } from 'react';
import { RiskDetails } from './RiskDetails';

export const Route = createFileRoute('/console/$orgId/risk/register/details/$id')({
    staticData: {
        ui: {
            widthVariant: 'default',
        },
        entity: 'risk',
    },
    params: {
        parse({ id }) {
            return {
                id: BigInt(id),
            };
        },
    },
    beforeLoad({ context: { trpcUtils }, params: { id } }): ShareableRouteContext {
        async function getTitle() {
            const risk = await trpcUtils.risk.getRisk.ensureData({ id });
            return `Risk details • ${formatRiskNumber(risk.id, risk.LevelOneCategory?.riskNumberPrefix)}`;
        }

        return {
            ui: { title: getTitle },
            breadcrumb: { title: getTitle },
        };
    },
    component: RouteComponent,
});

function RouteComponent() {
    return (
        <PageController route={Route}>
            <RiskManage />
        </PageController>
    );
}

function RiskManage() {
    const { id } = Route.useParams();

    useEffect(() => {
        document.getElementById(UI_SETTINGS.PAGE_LAYOUT_CONTAINER.ID)?.parentElement?.scrollTo({ top: 0, left: 0 });
    }, [id]);

    return (
        <>
            <RiskDetails />
            <div className="mt-4">
                <Tabs
                    items={[
                        {
                            label: 'Risk assessment',
                            to: '/console/$orgId/risk/register/details/$id/assessment',
                        },
                        {
                            label: 'Risk action plan',
                            to: '/console/$orgId/risk/register/details/$id/action-plan',
                        },
                        {
                            label: 'History',
                            to: '/console/$orgId/risk/register/details/$id/history',
                        },
                    ]}
                />
            </div>
        </>
    );
}
